import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCaret = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.48112 7.5C6.30318 7.5 6.21344 7.71531 6.33806 7.84232C7.12968 8.64906 7.90963 9.47448 8.73109 10.2496C8.88222 10.3922 9.11776 10.3922 9.26888 10.2495C10.0903 9.47436 10.8703 8.64904 11.6619 7.84231C11.7866 7.71531 11.6968 7.5 11.5189 7.5H6.48112Z",
		fill: "#949699"
	})
});
export { SvgIconCaret as ReactComponent };
